<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap> 
          <v-flex md6 class="col-12 fxt-bg-img" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                            
                <div class="fxt-form fxt-footer">                                              
                  <h3 class="fw-bold f-700 mb-3">
                    {{$t("registerSuccess.title")}}
                  </h3>
                  <div>
                    {{$t("registerSuccess.message")}}
                  </div>
                  <div class="mt-3">
                    <v-btn medium color="primary" @click="goHome">{{$t("allPage.homepage")}}</v-btn>
                </div>
                </div> 
                <div class="fxt-footer">
                    <ul class="fxt-socials">
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                            <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                        </li>
                    </ul>
                </div>
              </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>
<script>
import config from "../../config.js";
import $ from 'jquery';
export default {
  data() {
    return {
      domainName: config.ip
    };
  },
  //页面加载调用获取cookie值
  mounted() {
    //浏览器窗口发生变化时同时变化DIV高度
    window.onresize = this.autodivheight();
    this.background();
  },
  methods: {
    //自动获得div高度
    background(){
        $("[data-bg-image]").each(function() {
          var img = $(this).data("bg-image");
            $(this).css({
              backgroundImage: "url(" + img + ")"
            });
        })
    },
    autodivheight() {
      //函数：获取尺寸
      //获取浏览器窗口高度
      var winHeight = 0;
      if (window.innerHeight) {
        winHeight = window.innerHeight;
      } else if (document.body && document.body.clientHeight) {
        winHeight = document.body.clientHeight;
      } //通过深入Document内部对body进行检测，获取浏览器窗口高度
      if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
      }
      //DIV高度为浏览器窗口的高度:winHeight - 66
      //document.getElementById("content").style.height = winHeight + "px";
    },
    goHome() {
      window.location.href = config.ip;
    }
  }
};
</script>


// WEBPACK FOOTER //
// RegisterSuccess.vue?5a6c3f9d